import { useQuery } from '@tanstack/react-query';
import { getMe } from '../../api/auth.ts';
import { queryKeys } from '../../api/query-client.ts';

/** Perfil del cliente autenticado (`GET /v1/customers/me`). */
export function useMe() {
  return useQuery({ queryKey: queryKeys.me, queryFn: getMe, staleTime: 5 * 60_000 });
}
